import Header from '@propertypal/shared/src/resources/images/pn-devs/oakwood/header.png';
import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Text, TextProps } from '../../typography';
import DevelopmentContent, { DevelopmentSection } from './DevelopmentContent.pn';
import { DevHeaderImg, DevUnorderdList } from './DevelopmentContent.style.pn';

interface OakwoodContentProps {}

const OakwoodContent: React.FC<OakwoodContentProps> = () => {
  const theme = useTheme();

  const textProps = useMemo(() => {
    const p: TextProps = {
      fontSize: 17,
      lineHeight: 25,
      mt: 8,
      mb: 16,
      color: theme.textDark,
    };
    return p;
  }, [theme]);

  return (
    <div data-testid="oakwood-content">
      <DevelopmentContent bg="#dd0">
        <DevelopmentSection narrow>
          <DevHeaderImg src={Header.src} alt="Oakwood Development" />
          <DevUnorderdList {...textProps}>
            <li>Show House Open Sundays 2PM-4PM. For A Private Appointment Please Phone The Agents.</li>
            <li>PHASE 4 - EXCITING NEW PHASE ON RELEASE!</li>
            <li>SPECIFICATION</li>
            <li>KITCHEN &amp; UTILITY ROOMS</li>
            <li>
              High quality units with choice of soft close drawer, doors styles and colours. Choice of worktop and
              handle
            </li>
            <li>
              Integrated appliances to include gas hob, electric oven, extractor hood, fridge/freezer and dishwasher
            </li>
            <li>Integrated washing machine in kitchen where no utility room</li>
            <li>LED lighting to underside of kitchen units</li>
            <li>Recessed LED down lighters to kitchen ceiling</li>
            <li>Plumbing and electric supply for washing machine in utility room</li>
            <li>INTERNAL FEATURES</li>
            <li>Internal décor, walls and ceilings painted</li>
            <li>Multi fuel Stove with hearth</li>
            <li>Mains supply smoke detectors</li>
            <li>Mains supply Carbon monoxide detectors</li>
            <li>Moulded skirting and architraves</li>
            <li>Painted internal doors with quality ironmongery</li>
            <li>Comprehensive range of electrical sockets, switches, TV and telephone points</li>
            <li>Wiring for future satellite point</li>
            <li>Firmus fired central heating system</li>
            <li>Integral Alarm System</li>
            <li>BATHROOMS, EN-SUITES &amp; WC&apos;s</li>
            <li>Contemporary white sanitary ware with chrome fittings</li>
            <li>Thermostatically controlled Shower over bath with screen door where applicable</li>
            <li>Separate shower enclosure with thermostatically controlled shower where applicable</li>
            <li>Heated chrome towel radiator to main bathroom and ensuite</li>
            <li>LED recessed downlighters to main bathroom and ensuite</li>
            <li>FLOOR COVERINGS &amp; TILINGS</li>
            <li>
              Ceramic wall tiling between kitchen units Porcelain tiled floor to kitchen/dining area, utility, hall,
              bathroom, en-suite and WC
            </li>
            <li>Full height porcelain wall tiles to shower enclosure and wet areas to bath and sinks</li>
            <li>Carpets with underfelt to lounge, bedrooms, stairs and landing</li>
            <li>EXTERNAL FEATURES</li>
            <li>
              Soft landscaping to front gardens (where applicable) in keeping with other houses in the development.
              Planting to be carried out Spring/Summer (Weather dependant)
            </li>
            <li>Rear gardens rotovated and seeded</li>
            <li>Bitmac driveway</li>
            <li>uPVC double glazed windows with lockable system</li>
            <li>Composite front doors with painted finish</li>
            <li>Outside water tap</li>
            <li>Boundary fencing to side and rear of the back garden</li>
            <li>Feature external lighting to front and rear door</li>
            <li>10 year NHBC structural warranty</li>
          </DevUnorderdList>
          <Text {...textProps}>
            ABOUT OAKWOOD, ANTRIM Oakwood is located just off Stiles Way at the junction of the Birch Hill Road and
            Ballygore Road. A contemporary development of new build 3 &amp; 4 bedroom Semi-Detached and Detached homes.
            The delightful setting provides the perfect link for those working in Antrim town and commuters alike, with
            the town centre, train/bus station and the M2 Motorway all a few minutes drive. A high quality turnkey
            specification is offered and a range of options are provided for purchasers to customise their new home.
            Every purchaser will be invited to the Hilmark Get Ready Room where you will be able to personalise your
            home&apos;s move-in-ready finish. The homes in Oakwood will be built and finished to the highest standards
            perfect for a first time buyer, a growing family or downsizers alike. ABOUT THE DEVELOPER Hilmark Homes have
            an unwavering commitment to providing homes of exceptional quality. Recognised for their meticulous
            attention to detail and use of local craftsmen, they have successfully established themselves in providing
            quality homes that will stand the test of time for prospective purchasers. Hilmark combine innovative design
            with the use of carefully selected construction materials to ensure that their homes enhance their
            locations. They strive to put the customer first and endeavour to work along with them to ensure that they
            get the home they desire.
          </Text>
        </DevelopmentSection>
      </DevelopmentContent>
    </div>
  );
};

export default OakwoodContent;
